enum SectionTypes {
  SemBrandMarketingModule = 'SEMBrandMarketingModule',
  SemHeroModule = 'SEMHeroModule',
  SemInventoryModule = 'SEMInventoryModule',
  SemOpenListModule = 'SEMOpenListListModule',
  SemPanelListModule = 'SEMPanelListModule',
  SemSearchTilesModule = 'SEMSearchTilesModule',
  SemVehicleFeatureGridModule = 'SEMIconGridModule',
  SemActionBannerModule = 'SEMActionBannerModule'
}

export default SectionTypes;
